import {
  IGamePreviewFeature,
  PreviewFeatureEvaluationResult,
  PreviewFeatureType
} from './game-preview-feature.interface';
import {IServiceFactory} from '../../service-factory.interface';
import {GameInfo} from '../../games/game-info';

export class BooleanGamePreviewFeature implements IGamePreviewFeature {
  constructor(private _name: string, private _title: string, private _valueEvaluator: (gameInfo: GameInfo) => boolean) {
  }

  get name(): string {
    return this._name;
  }

  evaluate(services: IServiceFactory, gameInfo: GameInfo): PreviewFeatureEvaluationResult {
    return {
      title: services.translation.translate(this._title),
      value: this._valueEvaluator(gameInfo),
      type: PreviewFeatureType.check
    }
  }
}
